/**************************************************
 * Nombre:       Tarjeta_Razones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {NEGRITA} from "../../Constantes";
import tempo from '../../Recursos/foto_profundizacion.png'
import iso from "../../Recursos/iso_azul.svg";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Wass from "../Dialogos/Dialogo_Wass";


const Tarjeta_Razones = ({item}) => {
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Wass, titulo: 'Inciar Conversación'})

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Dialogo/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <img src={tempo} width={'100%'} height={'auto'}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 10}}
                sx={{
                    backgroundColor: theme.palette.primary.main,
                    p: 3,
                    color: '#fff',
                    mt: -10
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontFamily: NEGRITA, fontSize: 28, fontWeight: 800, lineHeight: 1.1}}>
                        Razon Uno
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                    <Typography sx={{fontSize: 16, fontWeight: 400, lineHeight: 1.2}}>
                        Programas prácticos diseñados para una empleabilidad rápida en sectores clave como tecnología,
                        administración, salud e industria
                        Programas prácticos diseñados para
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                    <Button
                        onClick={() => abrir({asunto: 'Razon uno'})}
                        color={'secondary'} sx={{fontSize: 14}}
                        startIcon={<img src={iso} style={{width: 20, height: 20, marginRight: 10}}/>}>
                        Mas Informacion
                    </Button>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Tarjeta_Razones